/**
 * Set of viewLevel numbers
 */
export class ViewLevelSet extends Set {
    /**
     * Add a whole set
     * @param other
     */
    addAll(other) {
        other.forEach((value) => {
            this.add(value);
        });
    }
    toJSON() {
        return Array.from(this.values());
    }
    toString() {
        return this.toJSON().toString();
    }
}
//# sourceMappingURL=ViewLevelSet.js.map